/**
 * Popular Categories — desktop tilt only (performance-optimized).
 * - Listeners on the five cards only
 * - getBoundingClientRect on pointerenter (not every move)
 * - One rAF per card max; transform only; ±2deg
 * - No mobile / coarse / reduced-motion tracking
 * - No scroll reveal (removed — caused delayed/unresponsive feel)
 */
(function () {
  var FINE =
    '(hover: hover) and (pointer: fine) and (min-width: 750px)';

  function enabled() {
    if (!document.body || !document.body.classList.contains('template-index')) return false;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return false;
    return window.matchMedia(FINE).matches;
  }

  function bindCard(card) {
    if (card.getAttribute('data-ks-pc-tilt') === '1') return;
    card.setAttribute('data-ks-pc-tilt', '1');

    var rect = null;
    var raf = 0;
    var latestX = 0;
    var latestY = 0;
    var pending = false;

    function apply() {
      pending = false;
      raf = 0;
      if (!rect || rect.width < 1 || rect.height < 1) return;
      var nx = ((latestX - rect.left) / rect.width) * 2 - 1;
      var ny = ((latestY - rect.top) / rect.height) * 2 - 1;
      if (nx > 1) nx = 1;
      if (nx < -1) nx = -1;
      if (ny > 1) ny = 1;
      if (ny < -1) ny = -1;
      card.style.transform =
        'translate3d(0, -3px, 0) rotateY(' +
        (nx * 2).toFixed(2) +
        'deg) rotateX(' +
        (-ny * 2).toFixed(2) +
        'deg)';
    }

    function onEnter(event) {
      rect = card.getBoundingClientRect();
      card.classList.add('is-pc-tilting');
      latestX = event.clientX;
      latestY = event.clientY;
    }

    function onMove(event) {
      latestX = event.clientX;
      latestY = event.clientY;
      if (pending) return;
      pending = true;
      raf = window.requestAnimationFrame(apply);
    }

    function onLeave() {
      if (raf) {
        window.cancelAnimationFrame(raf);
        raf = 0;
      }
      pending = false;
      rect = null;
      card.classList.remove('is-pc-tilting');
      card.style.transform = 'translate3d(0, 0, 0) rotateX(0deg) rotateY(0deg)';
    }

    card.addEventListener('pointerenter', onEnter, { passive: true });
    card.addEventListener('pointermove', onMove, { passive: true });
    card.addEventListener('pointerleave', onLeave, { passive: true });
    card.addEventListener('pointercancel', onLeave, { passive: true });
  }

  function boot() {
    if (!enabled()) return;
    var cards = document.querySelectorAll('.popular-categories .category-card-graphic');
    if (!cards.length) return;
    for (var i = 0; i < cards.length; i++) bindCard(cards[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function () {
    window.setTimeout(boot, 0);
  });
})();
